import withUser from '@/withUser';
import FrontLayout from '@layouts/FrontLayout';
import Head from 'next/head';
import Header from '@components/Header';
import React from 'react';
import Breadcrumb, { BreadcrumbItem } from '@components/app/Breadcrumb';
import UIWidth from '@components/presentational/UIWidth';
import Chapo from '@components/presentational/Chapo';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import UnfinishSignUpForm from '@components/UnfinishSignUpForm';
import { useRouter } from 'next/router';
import SubscribeImage from '../../../app/components/presentational/img/v2024/inscrivez-vous-connectez-vous/Istock513439341.webp';

function PageRegister() {
  const { push, query } = useRouter();

  return (
    <FrontLayout>
      <Head>
        <title>Créer mon compte | IFprofs</title>
      </Head>
      <Header />
      <Breadcrumb
        breadcrumbItems={[
          { label: 'Accueil', href: '/' },
          { label: 'Inscription' },
        ]}
      >
        <BreadcrumbItem label="Accueil" as={'/'} href={'/'} />
        <BreadcrumbItem label="Inscription" />
      </Breadcrumb>
      <section data-name="create-account">
        <UIWidth>
          <Chapo heading="Inscrivez-vous 1/2">
            <Text mb={{ base: '1rem', sm: '2rem' }}>
              Vous n’êtes qu’à quelques clics d’accéder à la richesse de la
              communauté IFprofs…
            </Text>
          </Chapo>
          <Flex
            direction={{ base: 'column', sm: 'row' }}
            gap={{ base: '1rem', sm: '1.25rem' }}
            align="flex-start"
            mb="2rem"
          >
            <Flex
              order={{ sm: 2 }}
              flexBasis={{ sm: '40%' }}
              alignItems="center"
              justifyContent="center"
              borderRadius="0 0 1.875rem 0"
              overflow="hidden"
            >
              <Image src={SubscribeImage.src} alt="" objectFit="cover" />
            </Flex>
            <Box flexGrow={1}>
              <UnfinishSignUpForm
                onSubmitEnd={(idUnfinishedSignup, country) => {
                  const queryData: {
                    country: string;
                    id: string;
                    invitationId?: string;
                    webinarId?: string;
                  } = {
                    country: country.code,
                    id: idUnfinishedSignup,
                  };
                  if (query.invitationId && query.webinarId) {
                    queryData.invitationId = query.invitationId as string;
                    queryData.webinarId = query.webinarId as string;
                  }
                  push(
                    {
                      pathname: '/s-inscrire/a-propos-de-vous',
                      query: queryData,
                    },
                    `/s-inscrire/a-propos-de-vous/${idUnfinishedSignup}`
                  ).then(() =>
                    window.scrollTo({
                      top: 0,
                      behavior: 'instant',
                    })
                  );
                }}
              />
            </Box>
          </Flex>
        </UIWidth>
      </section>
    </FrontLayout>
  );
}

export default withUser(PageRegister);
